module.exports = __webpack_public_path__ + "img/banner-mobile-3.4fb1ec0c.jpg";